// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
// import "../css/index.css";

// Import JS
// import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import "./placeholders";
import "./pagination";

// Call the menu and infinite scroll functions
// menuOpen();
infiniteScroll();

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('subscribe-form');
    const emailInput = document.getElementById('email-input');
    const submitButton = document.getElementById('submit-button');
    const messageSpan = document.getElementById('message');
    const arrowIcon = document.getElementById('arrow-icon');
    const spinnerIcon = document.getElementById('spinner-icon');

    let isLoading = false;
    let messageTimeout;

    // form.addEventListener('submit', async (event) => {
    //     event.preventDefault();
    //     const email = emailInput.value;

    //     if (isLoading) return;

    //     // Clear any previous messages
    //     clearMessage();

    //     if (!email || !/\S+@\S+\.\S+/.test(email)) {
    //         showMessage('Please enter a valid email address', 'error');
    //         return;
    //     }

    //     setLoading(true);

    //     try {
    //         const response = await fetch('/api/subscribe', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({ email }),
    //         });

    //         if (response.ok) {
    //             emailInput.value = ''; // Clear the input field
    //             showMessage('Subscribed Successfully', 'success');
    //         } else {
    //             showMessage('Failed to subscribe. Please try again.', 'error');
    //         }
    //     } catch (error) {
    //         console.error('Error submitting the form:', error);
    //         showMessage('An error occurred. Please try again later.', 'error');
    //     } finally {
    //         setLoading(false);
    //     }
    // });

    function setLoading(state) {
        isLoading = state;

        if (state) {
            // Show spinner, hide arrow
            spinnerIcon.classList.remove('hidden');
            arrowIcon.classList.add('hidden');
        } else {
            // Hide spinner, show arrow
            spinnerIcon.classList.add('hidden');
            arrowIcon.classList.remove('hidden');
        }
    }

    function showMessage(message, type) {
        clearTimeout(messageTimeout); // Clear any previous timeouts

        messageSpan.textContent = message;
        messageSpan.style.display = 'block';
        messageSpan.className = `text-xs absolute top-2 left-2 ${type === 'success' ? 'success-color' : 'error-color'}`;

        // Automatically hide the message after 5 seconds
        messageTimeout = setTimeout(() => {
            clearMessage();
        }, 5000);
    }

    function clearMessage() {
        messageSpan.style.display = 'none';
        messageSpan.textContent = '';
    }



    const blogMobileMenu = document.getElementById('blog-mobile-menu');
    const blogNavToggle = document.querySelector('.blog-nav-mobile-toggle');
    const blogMenuClose = document.querySelector('.blog-mobile-menu-close');
    const blogMenuLinks = document.querySelectorAll('.blog-mobile-nav-list a');

    function openBlogMobileMenu() {
        if (!blogMobileMenu) return;
        blogMobileMenu.classList.add('open');
        blogMobileMenu.setAttribute('aria-hidden', 'false');
        if (blogNavToggle) {
            blogNavToggle.classList.add('open');
            blogNavToggle.setAttribute('aria-expanded', 'true');
            blogNavToggle.setAttribute('aria-label', 'Close menu');
        }
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
    }

    function closeBlogMobileMenu() {
        if (!blogMobileMenu) return;
        blogMobileMenu.classList.remove('open');
        blogMobileMenu.setAttribute('aria-hidden', 'true');
        if (blogNavToggle) {
            blogNavToggle.classList.remove('open');
            blogNavToggle.setAttribute('aria-expanded', 'false');
            blogNavToggle.setAttribute('aria-label', 'Open menu');
        }
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }

    if (blogNavToggle) {
        blogNavToggle.addEventListener('click', (e) => {
            e.preventDefault();
            if (blogMobileMenu && blogMobileMenu.classList.contains('open')) {
                closeBlogMobileMenu();
            } else {
                openBlogMobileMenu();
            }
        });
    }

    if (blogMenuClose) {
        blogMenuClose.addEventListener('click', closeBlogMobileMenu);
    }

    if (blogMenuLinks && blogMenuLinks.length) {
        blogMenuLinks.forEach(link => {
            link.addEventListener('click', closeBlogMobileMenu);
        });
    }

    const useCasesDropdown = document.getElementById('blog-usecases');
    if (useCasesDropdown) {
        const toggle = useCasesDropdown.querySelector('.blog-nav-dropdown-toggle');
        if (toggle) {
            toggle.addEventListener('click', (e) => {
                e.stopPropagation();
                const isOpen = useCasesDropdown.classList.toggle('open');
                toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
            document.addEventListener('click', (e) => {
                if (!useCasesDropdown.contains(e.target)) {
                    useCasesDropdown.classList.remove('open');
                    toggle.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }

    const mobileUseCases = document.getElementById('blog-mobile-usecases');
    if (mobileUseCases) {
        const mobileToggle = mobileUseCases.querySelector('.blog-mobile-dropdown-toggle');
        if (mobileToggle) {
            mobileToggle.addEventListener('click', (e) => {
                e.preventDefault();
                const isOpen = mobileUseCases.classList.toggle('open');
                mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        }
    }


    const blogHeader = document.getElementById('blog-header');

    if (blogHeader) {
        const handleScroll = () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            if (scrollY > 0) {
                blogHeader.classList.add('scrolled');
            } else {
                blogHeader.classList.remove('scrolled');
            }
        };
        window.addEventListener('scroll', () => {
            requestAnimationFrame(handleScroll);
        }, { passive: true });
        handleScroll();
    }

    const searchResults = document.querySelector('.newsroom-search-results');
    if (searchResults) {
        const searchInput = document.getElementById('search-input');
        const heroChips = Array.from(document.querySelectorAll('.newsroom-hero-chip'));
        const latestChips = Array.from(document.querySelectorAll('.newsroom-latest-filter'));
        const featuredBlock = document.querySelector('.newsroom-featured-block');
        const latestRow = document.querySelector('.newsroom-latest-row');
        const newsroomLatest = document.querySelector('.newsroom-latest');
        const searchCount = searchResults.querySelector('.newsroom-search-count');
        const searchEmpty = searchResults.querySelector('.newsroom-search-empty');
        const searchCards = Array.from(searchResults.querySelectorAll('.newsroom-latest-card'));

        const latestCards = newsroomLatest ? Array.from(newsroomLatest.querySelectorAll('.newsroom-latest-card')) : [];
        const latestLoadMore = newsroomLatest ? newsroomLatest.querySelector('.newsroom-latest-loadmore') : null;
        const LATEST_STEP = 6;
        let latestVisible = LATEST_STEP;

        const renderLatest = () => {
            latestCards.forEach((card, index) => card.classList.toggle('is-hidden', index >= latestVisible));
            if (latestLoadMore) {
                latestLoadMore.style.display = latestCards.length > latestVisible ? '' : 'none';
            }
        };

        if (latestLoadMore) {
            latestLoadMore.addEventListener('click', () => {
                latestVisible += LATEST_STEP;
                renderLatest();
            });
        }

        let activeCategory = 'All';

        const syncChips = (chips) => chips.forEach(chip => chip.classList.toggle('is-active', chip.dataset.category === activeCategory));

        const applyView = () => {
            const query = (searchInput ? searchInput.value : '').trim().toLowerCase();
            const searching = query !== '' || activeCategory !== 'All';
            syncChips(heroChips);
            syncChips(latestChips);

            if (!searching) {
                searchResults.classList.add('newsroom-hide');
                if (featuredBlock) featuredBlock.classList.remove('newsroom-hide');
                if (latestRow) latestRow.classList.remove('newsroom-hide');
                latestVisible = LATEST_STEP;
                renderLatest();
                return;
            }

            searchResults.classList.remove('newsroom-hide');
            if (featuredBlock) featuredBlock.classList.add('newsroom-hide');
            if (latestRow) latestRow.classList.add('newsroom-hide');

            let matches = 0;
            searchCards.forEach(card => {
                const inCategory = activeCategory === 'All' || card.dataset.category === activeCategory;
                const inQuery = query === '' || (card.dataset.search || '').toLowerCase().indexOf(query) !== -1;
                const hit = inCategory && inQuery;
                card.classList.toggle('is-hidden', !hit);
                if (hit) matches += 1;
            });

            if (searchCount) searchCount.textContent = matches + (matches === 1 ? ' result' : ' results');
            if (searchEmpty) searchEmpty.classList.toggle('newsroom-hide', matches !== 0);
        };

        const setCategory = (category) => {
            activeCategory = category || 'All';
            applyView();
        };

        heroChips.forEach(chip => chip.addEventListener('click', () => setCategory(chip.dataset.category)));
        latestChips.forEach(chip => chip.addEventListener('click', () => setCategory(chip.dataset.category)));
        if (searchInput) searchInput.addEventListener('input', applyView);

        document.addEventListener('keydown', (event) => {
            if ((event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K')) {
                event.preventDefault();
                if (searchInput) searchInput.focus();
            }
        });

        renderLatest();
    }

    const notifyBtn = document.querySelector('.newsroom-trending-notify-btn');
    const notifyForm = document.querySelector('.newsroom-trending-notify-form');
    if (notifyBtn && notifyForm) {
        notifyBtn.addEventListener('click', () => {
            notifyBtn.hidden = true;
            notifyForm.hidden = false;
            const input = notifyForm.querySelector('input');
            if (input) input.focus();
        });
    }

    const authorArticles = document.querySelector('.newsroom-author-articles');
    if (authorArticles) {
        const cards = Array.from(authorArticles.querySelectorAll('.newsroom-author-article'));
        const loadMore = document.querySelector('.newsroom-author-loadmore');
        const wrap = document.querySelector('.newsroom-author-loadmore-wrap');
        const STEP = 5;
        let visible = STEP;

        const render = () => {
            cards.forEach((card, index) => card.classList.toggle('is-hidden', index >= visible));
            if (wrap) wrap.style.display = cards.length > visible ? '' : 'none';
        };

        if (loadMore) {
            loadMore.addEventListener('click', () => {
                visible += STEP;
                render();
            });
        }

        render();

        const statValue = document.querySelector('.newsroom-author-articles-count');
        if (statValue && !statValue.textContent.trim()) {
            statValue.textContent = cards.length;
        }

        const expertiseTags = Array.from(document.querySelectorAll('.newsroom-author-expertise-tag'));
        const seenTags = new Set();
        expertiseTags.forEach(tag => {
            const key = tag.textContent.trim().toLowerCase();
            if (!key || seenTags.has(key)) {
                tag.remove();
            } else {
                seenTags.add(key);
            }
        });
    }

    const authorsGrid = document.getElementById('authors-grid');
    if (authorsGrid) {
        const authorsSearch = document.getElementById('authors-search');
        const authorsSort = document.getElementById('authors-sort');
        const authorsCount = document.getElementById('authors-count');
        const authorsEmpty = document.getElementById('authors-empty');
        const authorCards = Array.from(authorsGrid.querySelectorAll('.newsroom-contributor'));
        let azSort = false;

        if (authorsCount) {
            authorsCount.textContent = authorCards.length + (authorCards.length === 1 ? ' contributor' : ' contributors');
        }

        const renderAuthors = () => {
            const query = (authorsSearch ? authorsSearch.value : '').trim().toLowerCase();
            let visible = authorCards.filter(card => !query || (card.dataset.name || '').toLowerCase().indexOf(query) !== -1);
            if (azSort) {
                visible = visible.slice().sort((a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || ''));
            }
            authorCards.forEach(card => { card.style.display = 'none'; });
            visible.forEach(card => { card.style.display = ''; authorsGrid.appendChild(card); });
            if (authorsEmpty) authorsEmpty.classList.toggle('newsroom-hide', visible.length !== 0);
        };

        if (authorsSearch) authorsSearch.addEventListener('input', renderAuthors);
        if (authorsSort) {
            authorsSort.addEventListener('click', () => {
                azSort = !azSort;
                authorsSort.classList.toggle('is-active', azSort);
                authorsSort.setAttribute('aria-pressed', azSort ? 'true' : 'false');
                renderAuthors();
            });
        }

        renderAuthors();
    }

    const subscribeForms = document.querySelectorAll('.newsroom-subscribe-form');
    subscribeForms.forEach(form => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            const emailInput = form.querySelector('.newsroom-subscribe-email');
            const messageEl = form.querySelector('.newsroom-subscribe-message');
            const submitBtn = form.querySelector('button[type="submit"]');
            const endpoint = form.dataset.subscribeUrl || '/api/newsroom/subscribe';
            const mode = form.dataset.subscribeMode || 'newsletter';
            const email = emailInput ? emailInput.value.trim() : '';

            const setMessage = (text, state) => {
                if (!messageEl) return;
                messageEl.textContent = text;
                messageEl.classList.remove('is-success', 'is-error');
                messageEl.classList.add(state === 'error' ? 'is-error' : 'is-success');
            };

            if (!email) {
                setMessage('Please enter a valid email address.', 'error');
                return;
            }

            const payload = { email: email };
            if (mode === 'notify') {
                payload.subscribe = false;
                payload.label = 'trending-waitlist';
            }

            if (submitBtn) submitBtn.disabled = true;
            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });
                const data = await response.json().catch(() => ({}));
                if (response.ok) {
                    setMessage(mode === 'notify'
                        ? "You're on the list — we'll email you when it launches."
                        : "You're subscribed — thanks for joining!", 'success');
                    if (emailInput) emailInput.value = '';
                } else {
                    setMessage(data.message || 'Subscription is temporarily unavailable. Please try again later.', 'error');
                }
            } catch (err) {
                setMessage('Subscription is temporarily unavailable. Please try again later.', 'error');
            } finally {
                if (submitBtn) submitBtn.disabled = false;
            }
        });
    });

    const copyBtn = document.querySelector('.newsroom-article-copy');
    if (copyBtn) {
        copyBtn.addEventListener('click', async () => {
            const url = copyBtn.dataset.url || window.location.href;
            try {
                if (navigator.share) {
                    await navigator.share({ url: url });
                } else {
                    await navigator.clipboard.writeText(url);
                    copyBtn.classList.add('newsroom-article-copied');
                    setTimeout(() => copyBtn.classList.remove('newsroom-article-copied'), 2000);
                }
            } catch (err) {
                copyBtn.classList.remove('newsroom-article-copied');
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Configure NProgress options to disable the spinner
    NProgress.configure({ showSpinner: false });

    // Stop NProgress when the page is fully loaded
    window.addEventListener('load', function () {
        NProgress.done();
    });

    // Trigger NProgress when clicking on anchor links
    const links = document.querySelectorAll('a');
    links.forEach(link => {
        link.addEventListener('click', function (event) {
            NProgress.start();
        });
    });
});